import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, forwardRef } from 'react';
import { IconButton as ChakraIconButton } from '@chakra-ui/react';
import { Icon } from '@caspeco/casper-ui-library.components.icon';
import { getIconSizeFromButtonSize } from './icon-button.helper';
/**
 * Button component with only an icon visible, used to trigger an action or event,
 * such as submitting a form, opening a Dialog, canceling an action, or performing a delete operation.
 *
 * @see Docs https://bit.cloud/caspeco/casper-ui-library/components/icon-button
 * @see WAI-ARIA https://www.w3.org/WAI/ARIA/apg/patterns/button
 */
export const IconButton = forwardRef(({ icon, size = 'md', variant = 'secondary', ...props }, ref) => {
    const iconSize = useMemo(() => getIconSizeFromButtonSize(size), [size]);
    return (_jsx(ChakraIconButton, { ref: ref, isRound: true, style: { aspectRatio: 1 }, variant: variant, size: size, icon: _jsx(Icon, { size: iconSize, icon: icon }), ...props }));
});
//# sourceMappingURL=icon-button.js.map